@import "../../../../../../../styles/variables";
@import "../../../../../../../styles/global";

:host {
  @media (max-width: $uiaas-tablet) {
    width: 100%;
  }
}

.product-card-dropdown {
  &-button {
    @media (max-width: $uiaas-tablet) {
      margin: 0px;
      width: 100%;
    }
    &--grid {
      margin: 0px;
      width: 100%;
    }
  }
}

.product-card-dropdown-button {
  position: relative;
  min-height: var(--qds-control-standard-height);
}
.product-card-dropdown-button__qds-button {
  display: block;
}
.product-card-dropdown-button__qds-button--loading {
  @media (min-width: $uiaas-tablet) {
    opacity: 0;
  }
}

.product-card-dropdown-button__spinner {
  pointer-events: none;
  opacity: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  left: calc(50% - 10px);
  top: calc(50% - 10px);
  transform: translate(-50%, -50%);
}

.product-card-dropdown-button__spinner--loading {
  @media (min-width: $uiaas-tablet) {
    opacity: 1;
  }
}
